import { HttpInterceptors } from "./http.interceptor";

export class SaleService extends HttpInterceptors {
	async getSaleByParams (filters) {
		const response = await this.axios.get("sale/getSaleByParams", { params: { filters } });
		return response.data;
	}

	async createSale (payload) {
		const response = await this.axios.post("sale/createSale", payload);
		return response.data;
	}

	async updateSale (payload) {
		const response = await this.axios.patch("sale/updateSale", payload);
		return response.data;
	}

	async deleteSale (payload) {
		const response = await this.axios.patch("sale/deleteSale", payload);
		return response.data;
	}

	async getProductsSaleByIdSale (filters) {
		const response = await this.axios.get("sale/getProductsSaleByIdSale", { params: { filters } });
		return response.data;
	}

}
